export type FeedbackInput = {
  freeText?: string;
  positive?: boolean;
  predefinedText?: string;
};
export enum FeedbackStates {
  none,
  positive,
  negative,
}
